import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from 'store'
import Cookies from 'js-cookie'

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_SUREFIRE_API,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token
    const user = (getState() as RootState).auth.user
    const locationId = Cookies.get('selectedLocation')

    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
      headers.set('cc-user-type', user?.type || '')
      headers.set('cc-user-id', user?.id || '')
      headers.set('admin-user', user?.first_name || '')
    }

    if (locationId) {
      headers.set('cc-location-id', locationId)
    }

    return headers
  }
})

// Enhanced baseQuery with logging
const baseQueryWithLogging = async (args: any, api: any, extraOptions: any) => {
  console.log('🌐 API Request:', {
    url: args.url,
    method: args.method,
    body: args.body,
    headers: args.headers,
    fullUrl: `${process.env.REACT_APP_SUREFIRE_API}/${args.url}`
  });

  const result = await baseQuery(args, api, extraOptions);
  
  console.log('🌐 API Response:', {
    url: args.url,
    status: result.meta?.response?.status,
    statusText: result.meta?.response?.statusText,
    hasData: !!result.data,
    hasError: !!result.error,
    error: result.error
  });

  return result;
};

export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithLogging,
  keepUnusedDataFor: 0,
  tagTypes: [
    'DashboardStats',
    'Customers',
    'UserInfo',
    'Entries',
    'Settings',
    'Affiliates',
    'AffiliateDetail',
    'Orders',
    'Locations',
    'BookingSlots',
    'TeamMembers',
    'Reports',
    'Certifications'
  ],
  endpoints: () => ({})
})
